module.exports = __webpack_public_path__ + "static/media/user.607dc9f8.png";